import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TuiLegendItem } from '@taiga-ui/addon-charts';
import { TuiIslandDirective, TuiPrimitiveTextfieldModule } from '@taiga-ui/legacy';
import { TuiAccordion, TuiBadge, TuiSwitch, TuiCheckbox } from '@taiga-ui/kit';
import {
  TuiDataList,
  TuiLoader,
  TuiGroup,
  TuiLabel,
  TuiDropdown,
  TuiIcon,
  TuiLink,
  TuiButton,
  TuiHint,
  TuiTextfield,
  TuiScrollbar,
} from '@taiga-ui/core';
import { TuiAutoFocus } from '@taiga-ui/cdk';
import { NgxPermissionsModule } from 'ngx-permissions';
import { SharedModule } from '@src/app/shared';
import { IconModule } from '@src/app/modules/icon';
import { PhotoModule } from '@src/app/modules/photo';

import { TermOfThePrivacyComponent } from './term-of-the-privacy/term-of-the-privacy.component';
import { MobileAppDownloadLinksComponent } from './mobile-app-download-links/mobile-app-download-links.component';
import { SkeletonRowComponent } from './skeleton-row/skeleton-row.component';
import { SkeletonWrapperComponent } from './skeleton-wrapper/skeleton-wrapper.component';
import { CopyToClipboardButtonComponent } from './copy-to-clipboard-button/copy-to-clipboard-button.component';
import { ParseLinksComponent } from './parse-links/parse-links.component';
import { SearchComponent } from './search';
import { BadgeComponent } from './badge';
import { LabelComponent } from './label/label.component';
import { PreviewButtonComponent } from './preview-button/preview-button.component';
import { ToggleComponent } from './toggle/toggle.component';
import { HeaderComponent } from './header/header.component';
import { LoaderWrapperComponent } from './loader-wrapper/loader-wrapper.component';
import { MoreButtonComponent } from './more-button';
import { LegendComponent } from './legend';
import { ConfirmDialogComponent } from './confirm-dialog/confirm-dialog.component';
import { AccordionSelectionComponent } from './accordion-selection/accordion-selection.component';
import { ParseMultimediaLinksComponent } from './parse-multimedia-links';
import { LinkComponent } from './link/link.component';
import { WhatsAppLinkComponent } from './whats-app-link/whats-app-link.component';
import { TelegramLinkComponent } from './telegram-link/telegram-link.component';
import { DownloadLinkComponent } from './download-link/download-link.component';
import { FieldWrapperComponent } from './field-wrapper/field-wrapper.component';
import { DescriptionComponent } from './description/description.component';
import { FieldWrapperOldComponent } from './field-wrapper-old/field-wrapper-old.component';
import { ScalableFontComponent } from './scalable-font/scalable-font.component';

@NgModule({
  declarations: [
    BadgeComponent,
    TermOfThePrivacyComponent,
    MobileAppDownloadLinksComponent,
    SkeletonRowComponent,
    SkeletonWrapperComponent,
    CopyToClipboardButtonComponent,
    ParseLinksComponent,
    SearchComponent,
    BadgeComponent,
    LabelComponent,
    PreviewButtonComponent,
    ToggleComponent,
    HeaderComponent,
    LoaderWrapperComponent,
    MoreButtonComponent,
    LegendComponent,
    ConfirmDialogComponent,
    AccordionSelectionComponent,
    ParseMultimediaLinksComponent,
    LinkComponent,
    WhatsAppLinkComponent,
    TelegramLinkComponent,
    DownloadLinkComponent,
    FieldWrapperComponent,
    FieldWrapperOldComponent,
    DescriptionComponent,
    ScalableFontComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    IconModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    TuiAutoFocus,
    TuiBadge,
    TuiButton,
    ...TuiDataList,
    ...TuiDropdown,
    TuiLabel,
    TuiLegendItem,
    TuiLoader,
    TuiLink,
    TuiIcon,
    TuiSwitch,
    TuiPrimitiveTextfieldModule,
    ...TuiAccordion,
    ...TuiHint,
    ...TuiTextfield,
    TuiGroup,
    DragDropModule,
    PhotoModule,
    TuiIslandDirective,
    NgxPermissionsModule,
    TuiCheckbox,
    TuiScrollbar,
  ],
  exports: [
    BadgeComponent,
    CopyToClipboardButtonComponent,
    LabelComponent,
    TermOfThePrivacyComponent,
    MobileAppDownloadLinksComponent,
    ParseLinksComponent,
    PreviewButtonComponent,
    SearchComponent,
    SkeletonRowComponent,
    SkeletonWrapperComponent,
    ToggleComponent,
    HeaderComponent,
    LoaderWrapperComponent,
    MoreButtonComponent,
    LegendComponent,
    AccordionSelectionComponent,
    ParseMultimediaLinksComponent,
    LinkComponent,
    WhatsAppLinkComponent,
    TelegramLinkComponent,
    DownloadLinkComponent,
    FieldWrapperComponent,
    FieldWrapperOldComponent,
    DescriptionComponent,
    ScalableFontComponent,
  ],
})
export class ComponentsModule {}
